import { BookEnum } from '@interfaces/BookEnum'
import { ChartOptionType } from '@interfaces/ChartOptionType'
import { Expose, Transform } from 'class-transformer'

export class WriterSalesAnalyticsOverviewDataType {
  @Expose()
  bookTitle: string

  @Expose()
  @Transform(({ value }) =>
    value === BookEnum.MANGA
      ? 'การ์ตูน'
      : value === BookEnum.NOVEL
      ? 'นิยาย'
      : ''
  )
  bookType: string

  @Expose()
  sales: number

  @Expose()
  donation: number

  @Expose()
  viewCount: number

  @Expose()
  likeCount: number

  @Expose()
  shelfAddedCount: number

  @Expose()
  commentCount: number

  @Expose()
  @Transform(({ obj }) => {
    return [
      { value: obj?.genderDetail.maleReader || 0, name: 'ชาย' },
      { value: obj?.genderDetail.femaleReader || 0, name: 'หญิง' },
      { value: obj?.genderDetail.otherReader || 0, name: 'ไม่ระบุเพศ' },
    ]
  })
  genderDetail: ChartOptionType[]

  @Expose()
  @Transform(({ obj }) => {
    return [
      { value: obj?.ageDetail.ageBelowFifthteen || 0, name: 'ต่ำกว่า 15' },
      { value: obj?.ageDetail.ageBetweenSixteenAndTwenty || 0, name: '16-20' },
      {
        value: obj?.ageDetail.ageBetweenTwentyoneAndThirty || 0,
        name: '21-30',
      },
      { value: obj?.ageDetail.ageBetweenThirtyoneAndForty || 0, name: '31-40' },
      {
        value: obj?.ageDetail.ageBetweenFortyoneAndFifty || 0,
        name: '41 ขึ้นไป',
      },
      { value: obj?.ageDetail.otherAge || 0, name: 'ไม่ระบุ' },
    ]
  })
  ageDetail: ChartOptionType[]
}
